import "./Platform.css"
export default function SmartPlatform(props) {
    return props.ModuleDetails.map((md, index) => {
        return <button
            className="smartPlatform"
            key={index}
            style={{
                backgroundColor: md.BackgroundColor,
                color: md.SubTitleForeColor
            }}
            onClick={() =>
                (window.location.href = md.URL)
            }
        >
            <img src="https://s2.uupload.ir/files/image_2023-02-14_09-28-25-removebg-preview_usmv.png"></img>
            {md ? md.Title : ""}
        </button>
    })
}